import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import CalculatingScreen from "../components/CalculatingScreen";
import { dayQueryOptions } from "../lib/queries";
import { resultSearchSchema } from "../lib/searchParams";
import ResultsPage from "../pages/ResultsPage";

export const Route = createFileRoute("/resultat")({
	validateSearch: zodValidator(resultSearchSchema),
	loaderDeps: ({ search }) => ({ lat: search.lat, lon: search.lon, date: search.date }),
	loader: ({ context, deps }) => context.queryClient.ensureQueryData(dayQueryOptions(deps)),
	pendingComponent: () => <CalculatingScreen label="Beregner soltider..." />,
	component: ResultsPage,
});
